import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaSquareXTwitter, FaWhatsapp } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div>
      <footer id="footer" className="footer light-background">
        <div className="container footer-top">
          <div className="row gy-4 leftspace">
            {/* Footer About */}
            <div className="col-lg-5 col-md-6 footer-about">
              <h4> {t('footer.clinic_name')}</h4>
              <div className="footer-contact">
                <strong>{t('footer.address')}:</strong>{" "}
                <Link to='https://maps.app.goo.gl/5P19RsUVGskXwXQG6' target='_blank' className='text-decoration-none'>
                  <p>{t('footer.address_text')}</p>
                </Link>

                <p className="mt-3">
                  <strong>{t('footer.phone')}:</strong>
                  <Link to="tel:+918989447040" className='text-dark fs-6 text-decoration-none'>
                    <span className='text-dark fs-6 pl-2'>8989447040</span>
                  </Link>
                  <Link to="tel:+919039303090" className='text-dark fs-6 text-decoration-none'>
                    <span className='text-dark fs-6 pl-2'>9039303090</span>
                  </Link>
                </p>

                <p>
                  <strong>{t('footer.email')}: </strong>
                  <Link to="mailto:homesexologyclinic@gmail.com" className='text-dark fs-6 pl-2 text-decoration-none'>
                    homesexologyclinic@gmail.com
                  </Link>
                </p>
              </div>

              <div className="social-links d-flex mt-4">
                <Link to="https://x.com" target="_blank" className="twitter footericons text-decoration-none">
                  <FaSquareXTwitter />
                </Link>
                <Link to="https://www.facebook.com" target="_blank" className="facebook footericons">
                  <FaFacebook />
                </Link>
                <Link to="https://www.instagram.com" target="_blank" className="instagram footericons">
                  <FaInstagram />
                </Link>
                <Link to="https://youtube.com" target="_blank" className="youtube footericons">
                  <IoLogoYoutube />
                </Link>
                <Link to="https://wa.me/919039303090" target="_blank" className="whatsapp footericons">
                  <FaWhatsapp />
                </Link>
              </div>
            </div>

            {/* Spacer Column */}
            <div className='col-lg-1'></div>

            {/* Quick Links and Our Services in one row even on mobile */}
            <div className="col-lg-6 col-md-6">
              <div className="row">
                {/* Quick Links */}
                <div className="col-6 footer-links">
                  <h4>{t('footer.quick_links')}</h4>
                  <ul>
                    <li><Link to="/" className='text-decoration-none text-dark fs-6'>{t('header.home')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('header.services')}</Link></li>
                    <li><Link to="/medicines" className='text-decoration-none text-dark fs-6'>{t('header.medicines')}</Link></li>
                    <li><Link to="/aboutus" className='text-decoration-none text-dark fs-6'>{t('header.about')}</Link></li>
                    <li><Link to="/contact" className='text-decoration-none text-dark fs-6'>{t('header.contact')}</Link></li>
                  </ul>
                </div>

                {/* Current Services */}
                <div className="col-6 footer-links">
                  <h4>{t('footer.current_services')}</h4>
                  <ul>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.strength_stamina')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.timing_concern')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.less_desire')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.male_problem')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.performance_anxiety')}</Link></li>
                    <li><Link to="/services" className='text-decoration-none text-dark fs-6'>{t('services.male.fertility_support')}</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className='copyright'>
          <div className="container copyright text-center">
            <p>© <span>Copyright 2024</span> <strong className="px-1 sitename">Sexologist Clinic</strong> <span>{t('footer.copyright')}</span></p>
            <div className="credits">
              {t('footer.developed_by')} <Link to="https://yashsoftsolution.com/" target="_blank" className='text-decoration-none text-light fs-6'>Yashsoft Solution</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
